import { Observable } from 'rxjs'
import { filter, startWith, switchMap, tap } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'

import { OperationInternalEvent } from '../operation-internal-event'
import { operationInternalEventActions } from '../operation-internal-event.actions'
import { operationInternalEventSelectors } from '../operation-internal-event.selectors'

@Component({
  selector: 'operation-internal-event-show',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class OperationInternalEventShowComponent implements OnInit {
  public operationInternalEvent$: Observable<OperationInternalEvent>
  public operationInternalEventId$: Observable<number>
  public isLoading$: Observable<boolean>

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.isLoading$ = this.store
      .select(operationInternalEventSelectors.selectIsLoading)
      .pipe(startWith(false))

    this.operationInternalEventId$ = this.store
      .select(operationInternalEventSelectors.selectIdRouteParam)
      .pipe(filter((id) => Boolean(id)))

    this.operationInternalEvent$ = this.operationInternalEventId$.pipe(
      tap((id) =>
        this.store.dispatch(
          operationInternalEventActions.fetchOneById({
            id
          })
        )
      ),
      switchMap((operationInternalEventId) =>
        this.store.select(
          operationInternalEventSelectors.selectById,
          operationInternalEventId
        )
      )
    )
  }
}
